import { bootstrapApplication } from '@angular/platform-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// MSAL names its sign-in popups "msal.<clientId>..." and waits for the auth response on a BroadcastChannel.
// The redirect bridge posts it from here and closes the popup; booting the app would consume the response instead.
const inMsalPopup = window.opener !== null && window.opener !== window && window.name.startsWith('msal.');

if (inMsalPopup) {
  broadcastResponseToMainFrame().catch((err) => console.error(err));
} else {
  bootstrapApplication(App, appConfig).catch((err) => console.error(err));
}
